import { render, staticRenderFns } from "./EditFields.vue?vue&type=template&id=c2eecbe0"
import script from "./EditFields.vue?vue&type=script&lang=js"
export * from "./EditFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports